import React, { Component } from 'react';
import { Map, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import './SimpleMap.css';
export default class SimpleMap extends Component {
  constructor(props) {
    super(props);
    this.handleMove = this.handleMove.bind(this);
  }
  zoomLevel = 2;
  centerPosition = [0,0]

  handleMove(event){
    this.zoomLevel = event.target.getZoom();
    this.centerPosition = [event.target.getCenter().lat,event.target.getCenter().lng]
    // TL;DR Javascript is a shit language
    this.props.getCurrentBounds(Object.getPrototypeOf(this.refs.mapObject.leafletElement).getBounds.call(this.refs.mapObject.leafletElement));
  }

  render() {
    const items = this.props.items;
    const isLoaded = items.length > 0;
    if (!isLoaded) {
      return <div>Loading...</div>;
    } else {
    const icon = L.icon({
      iconUrl: require('../images/marker.png'),
      iconSize: [32,32],
      iconAnchor: null,
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null
    });
    const markers = items.map((item,i) => 
    (<Marker id={item.id} icon={icon} customProp={item.id} onClick={this.props.selectPhoto} key={item.id} position={[item.location.latitude, item.location.longitude]}>
    {/* <Popup>
      <h3>{item.author}</h3>
      <img style={{width:"150px", height: "150px"}} alt={item.title} src={item.smallSizeUrl}/>
    </Popup> */}
  </Marker>
  ));
    return (
      <Map ref='mapObject' id="mymap" onClick={this.props.unselectPhoto} onmoveend={this.handleMove} zoom={this.zoomLevel} center={this.centerPosition}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        {markers}
      </Map>

    )
  }
}
}